// From the typed list to pages: one sticker per line of the list ("|" starts a second line inside a sticker), blank lines
// skipped; stickers fill each page left to right, one page per row of the roll.
import { ROLL_WIDTH_MM, type Columns } from '../model/options';

export type Sticker = string[]; // the sticker's lines of text

export function parseStickers(text: string): Sticker[] {
  return text.split(/\r?\n/)
    .map((line) => line.split('|').map((part) => part.trim()).filter(Boolean))
    .filter((lines) => lines.length > 0);
}

export function toPages(stickers: Sticker[], columns: Columns): Sticker[][] {
  const pages: Sticker[][] = [];
  for (let i = 0; i < stickers.length; i += columns) pages.push(stickers.slice(i, i + columns));
  return pages;
}

export const cellWidthMm = (columns: Columns) => ROLL_WIDTH_MM / columns;
